const findParentKeys = (nodes, targetKey, parents = []) => {
    for (let node of nodes) {
        if (node.key === targetKey) {
            return parents;
        }
        if (node.children) {
            const foundParents = findParentKeys(node.children, targetKey, [...parents, node.key]);
            if (foundParents.length > 0) {
                return foundParents;
            }
        }
    }
    return [];
};

const toTreeData = (lst) => {
    if (lst.length == 0) {
        return [];
    }

    var root = lst.find((x) => x.is_root);
    var arrarLoop = [];
    var tree = {
        value: root.id,
        title: root.name,
        children: [],
        id: root.id,
        key: root.id,
        isRoot: true,
        isLeaf: true,
    };
    arrarLoop.push(tree);

    while (arrarLoop.length > 0) {
        var node = arrarLoop.pop();

        var children = lst
            .filter((x) => x.parent_id === node.id)
            .map((x) => ({ value: x.id, title: x.name, id: x.id, children: [], key: x.id, sort_index: x.sort_index || "-1" }))
            .sort((a, b) => {
                const aIndex = parseInt(a.sort_index, 10);
                const bIndex = parseInt(b.sort_index, 10);
                return aIndex - bIndex;
            });

        node.children = children;
        node.children.forEach((childNode) => {
            arrarLoop.push(childNode);
        });
    }
    // tree.id='root'

    console.log({ tree });
    return [tree];
};

export { findParentKeys, toTreeData };
